const defaults = {
  to: '',
  cc: '',
  bcc: '',
  subject: '',
  body: '',
  isHtml: false,
  attachments: '',
};

export default defaults;
